export const AreaIcon = ({ id }) => {
  switch (id) {
    case "Kust":
      return <Kust />;

    case "Stad":
      return <Stad />;

    case "Glas":
      return <Glas />;

    case "Gras":
      return <Gras />;

    default:
      return <Organisatie />;
  }
};

const Kust = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_348_4893)">
      <path
        d="M34.1463 13.0732C32.4878 13.0732 31.0244 11.7073 31.0244 9.95122C31.0244 8.29268 32.3902 6.82927 34.1463 6.82927C35.8049 6.82927 37.2683 8.19512 37.2683 9.95122C37.2683 11.7073 35.9024 13.0732 34.1463 13.0732ZM34.1463 33.7561C32.4878 33.7561 31.0244 32.3902 31.0244 30.6341C31.0244 28.9756 32.3902 27.5122 34.1463 27.5122C35.8049 27.5122 37.2683 28.878 37.2683 30.6341C37.2683 32.3902 35.9024 33.7561 34.1463 33.7561ZM27.2195 23.3171C25.561 23.3171 24.0976 21.9512 24.0976 20.1951C24.0976 18.5366 25.4634 17.0732 27.2195 17.0732C28.878 17.0732 30.3415 18.439 30.3415 20.1951C30.2439 21.9512 28.878 23.3171 27.2195 23.3171ZM20.4878 13.0732C18.8293 13.0732 17.3659 11.7073 17.3659 9.95122C17.3659 8.29268 18.7317 6.82927 20.4878 6.82927C22.1463 6.82927 23.6098 8.19512 23.6098 9.95122C23.5122 11.7073 22.1463 13.0732 20.4878 13.0732ZM20.4878 33.7561C18.8293 33.7561 17.3659 32.3902 17.3659 30.6341C17.3659 28.9756 18.7317 27.5122 20.4878 27.5122C22.1463 27.5122 23.6098 28.878 23.6098 30.6341C23.5122 32.3902 22.1463 33.7561 20.4878 33.7561ZM13.4634 23.3171C11.8049 23.3171 10.3415 21.9512 10.3415 20.1951C10.3415 18.5366 11.7073 17.0732 13.4634 17.0732C15.122 17.0732 16.5854 18.439 16.5854 20.1951C16.5854 21.9512 15.2195 23.3171 13.4634 23.3171ZM6.73171 13.0732C5.07317 13.0732 3.60976 11.7073 3.60976 9.95122C3.60976 8.29268 4.97561 6.82927 6.73171 6.82927C8.39024 6.82927 9.85366 8.19512 9.85366 9.95122C9.85366 11.7073 8.39024 13.0732 6.73171 13.0732ZM6.73171 33.7561C5.07317 33.7561 3.60976 32.3902 3.60976 30.6341C3.60976 28.9756 4.97561 27.5122 6.73171 27.5122C8.39024 27.5122 9.85366 28.878 9.85366 30.6341C9.85366 32.3902 8.39024 33.7561 6.73171 33.7561ZM37.561 20.1951C37.561 18.7317 38.6341 17.4634 40 17.1707V5.56098C40 4.09756 39.4146 2.73171 38.439 1.7561L38.3415 1.65854C37.3659 0.682927 35.9024 0 34.439 0H30.2439C30.0488 1.46341 28.7805 2.63415 27.2195 2.63415C25.6585 2.63415 24.3902 1.46341 24.1951 0H16.5854C16.3902 1.46341 15.122 2.63415 13.561 2.63415C12 2.63415 10.7317 1.46341 10.5366 0H5.56098C4.09756 0 2.82927 0.585366 1.85366 1.46341C1.65854 1.65854 1.46341 1.85366 1.26829 2.04878C0.487805 3.02439 0 4.19512 0 5.56098V17.1707C1.46341 17.4634 2.53659 18.7317 2.53659 20.1951C2.53659 21.6585 1.46341 22.9268 0 23.2195V34.439C0 37.561 2.53659 40 5.56098 40H10.2439C10.5366 38.6341 11.8049 37.6585 13.2683 37.6585C14.7317 37.6585 15.9024 38.6341 16.2927 40H24.0976C24.3902 38.6341 25.6585 37.6585 27.0244 37.6585C28.4878 37.6585 29.6585 38.6341 29.9512 40H34.5366C37.561 40 40.0976 37.4634 40.0976 34.439V23.2195C38.6341 22.9268 37.561 21.6585 37.561 20.1951Z"
        fill="white"
      />
      <path
        d="M27.3171 2.63415C28.8781 2.63415 30.1464 1.46341 30.3415 0H24.2927C24.4878 1.46341 25.7561 2.63415 27.3171 2.63415Z"
        fill="#F7991C"
      />
      <path
        d="M13.1706 37.6584C11.7072 37.6584 10.5365 38.6341 10.1462 39.9999H16.0975C15.9023 38.7316 14.634 37.6584 13.1706 37.6584Z"
        fill="#F7991C"
      />
      <path
        d="M13.561 2.63415C15.122 2.63415 16.3903 1.46341 16.5854 0H10.5366C10.7317 1.46341 12 2.63415 13.561 2.63415Z"
        fill="#F7991C"
      />
      <path
        d="M26.9268 37.7561C25.4634 37.7561 24.2927 38.7317 24 40.0976H29.9512C29.561 38.7317 28.3902 37.7561 26.9268 37.7561Z"
        fill="#F7991C"
      />
      <path
        d="M38.5365 1.75601L38.439 1.65845C38.439 1.65845 38.439 1.75601 38.5365 1.75601Z"
        fill="#F7991C"
      />
      <path
        d="M1.85368 1.46338C1.65855 1.56094 1.46343 1.75606 1.26831 2.04874C1.46343 1.85362 1.65855 1.6585 1.85368 1.46338Z"
        fill="#F7991C"
      />
      <path
        d="M2.53659 20.195C2.53659 18.7316 1.46341 17.4633 0 17.1707V23.2194C1.46341 22.9267 2.53659 21.756 2.53659 20.195Z"
        fill="#F7991C"
      />
      <path
        d="M27.2196 17.1707C25.5611 17.1707 24.0977 18.5365 24.0977 20.2926C24.0977 21.9511 25.4635 23.4146 27.2196 23.4146C28.8781 23.4146 30.3416 22.0487 30.3416 20.2926C30.244 18.5365 28.8781 17.1707 27.2196 17.1707Z"
        fill="#F7991C"
      />
      <path
        d="M20.4879 6.92676C18.8294 6.92676 17.366 8.29261 17.366 10.0487C17.366 11.7072 18.7318 13.1707 20.4879 13.1707C22.1465 13.1707 23.6099 11.8048 23.6099 10.0487C23.5123 8.29261 22.1465 6.92676 20.4879 6.92676Z"
        fill="#F7991C"
      />
      <path
        d="M20.4879 27.6099C18.8294 27.6099 17.366 28.9757 17.366 30.7318C17.366 32.3904 18.7318 33.8538 20.4879 33.8538C22.1465 33.8538 23.6099 32.4879 23.6099 30.7318C23.5123 28.9757 22.1465 27.6099 20.4879 27.6099Z"
        fill="#F7991C"
      />
      <path
        d="M37.561 20.195C37.561 21.6585 38.6342 22.9267 40.0001 23.2194V17.1707C38.6342 17.4633 37.561 18.7316 37.561 20.195Z"
        fill="#F7991C"
      />
      <path
        d="M34.1464 6.92676C32.4878 6.92676 31.0244 8.29261 31.0244 10.0487C31.0244 11.7072 32.3903 13.1707 34.1464 13.1707C35.8049 13.1707 37.2683 11.8048 37.2683 10.0487C37.2683 8.29261 35.9025 6.92676 34.1464 6.92676Z"
        fill="#F7991C"
      />
      <path
        d="M34.1464 27.6099C32.4878 27.6099 31.0244 28.9757 31.0244 30.7318C31.0244 32.3904 32.3903 33.8538 34.1464 33.8538C35.8049 33.8538 37.2683 32.4879 37.2683 30.7318C37.2683 28.9757 35.9025 27.6099 34.1464 27.6099Z"
        fill="#F7991C"
      />
      <path
        d="M13.4635 17.1707C11.805 17.1707 10.3416 18.5365 10.3416 20.2926C10.3416 21.9511 11.7074 23.4146 13.4635 23.4146C15.122 23.4146 16.5855 22.0487 16.5855 20.2926C16.5855 18.5365 15.2196 17.1707 13.4635 17.1707Z"
        fill="#F7991C"
      />
      <path
        d="M6.73181 6.92676C5.07328 6.92676 3.60986 8.29261 3.60986 10.0487C3.60986 11.7072 4.97572 13.1707 6.73181 13.1707C8.39035 13.1707 9.85377 11.8048 9.85377 10.0487C9.85377 8.29261 8.39035 6.92676 6.73181 6.92676Z"
        fill="#F7991C"
      />
      <path
        d="M6.73181 27.6099C5.07328 27.6099 3.60986 28.9757 3.60986 30.7318C3.60986 32.3904 4.97572 33.8538 6.73181 33.8538C8.39035 33.8538 9.85377 32.4879 9.85377 30.7318C9.85377 28.9757 8.39035 27.6099 6.73181 27.6099Z"
        fill="#F7991C"
      />
    </g>
    <defs>
      <clipPath id="clip0_348_4893">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Stad = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.9999 6.00442V5.53348C39.9999 2.50184 37.4981 0 34.437 0H20.0146V6.00442H39.9999Z"
      fill="#B72845"
    />
    <path
      d="M0 5.56291V6.03385H20.0147V0H5.56291C2.50184 0 0 2.50184 0 5.56291Z"
      fill="white"
    />
    <path d="M39.9999 6.00439H20.0146V12.8624H39.9999V6.00439Z" fill="white" />
    <path d="M20.0147 6.00439H0V12.8624H20.0147V6.00439Z" fill="#B72845" />
    <path
      d="M39.9999 12.8625H20.0146V19.7205H39.9999V12.8625Z"
      fill="#B72845"
    />
    <path d="M20.0147 12.8625H0V19.7205H20.0147V12.8625Z" fill="white" />
    <path d="M39.9999 19.7205H20.0146V26.5784H39.9999V19.7205Z" fill="white" />
    <path d="M20.0147 19.7205H0V26.5784H20.0147V19.7205Z" fill="#B72845" />
    <path
      d="M39.9999 26.6077H20.0146V33.4656H39.9999V26.6077Z"
      fill="#B72845"
    />
    <path d="M20.0147 26.6077H0V33.4656H20.0147V26.6077Z" fill="white" />
    <path
      d="M20.0146 40H34.437C37.4981 40 39.9999 37.4982 39.9999 34.4371V33.4658H20.0146V40Z"
      fill="white"
    />
    <path
      d="M0 33.4658V34.4371C0 37.4982 2.50184 40 5.56291 40H20.0147V33.4658H0Z"
      fill="#B72845"
    />
  </svg>
);

const Glas = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_348_5093)">
      <path
        d="M5.54456 0C2.48939 0 0 2.48939 0 5.54456V7.52475L16.3791 0H5.54456Z"
        fill="white"
      />
      <path
        d="M40.0002 5.54456C40.0002 2.4611 37.5109 0 34.4557 0H23.7061L40.0002 7.77935V5.54456Z"
        fill="white"
      />
      <path
        d="M2.5459 39.0947C3.42284 39.6605 4.44123 39.9999 5.57277 39.9999H14.0593C16.6619 38.8118 20.1131 37.1994 20.1131 37.1994L25.9688 39.9999H34.4271C35.4455 39.9999 36.4073 39.7171 37.2277 39.2362L20.0565 31.0325L2.5459 39.0947Z"
        fill="white"
      />
      <path
        d="M0 11.1173V17.2559L20.1132 8.00556L40 17.5105V11.4002L20.0849 1.86694L0 11.1173Z"
        fill="white"
      />
      <path
        d="M0 20.8205V26.9591L20.1132 17.737L40 27.2137V21.1033L20.0849 11.5984L0 20.8205Z"
        fill="white"
      />
      <path
        d="M0 30.5517V34.4555C0 35.191 0.141443 35.8699 0.39604 36.5205L20.1132 27.4682L39.5191 36.7468C39.8303 36.0396 40 35.2758 40 34.4838V30.8345L20.0849 21.3296L0 30.5517Z"
        fill="white"
      />
      <path
        d="M0 26.9591V30.5518L20.0849 21.3014L40 30.8347V27.242L20.1132 17.7371L0 26.9591Z"
        fill="#4C91BF"
      />
      <path
        d="M0.395996 36.5206C0.820324 37.5955 1.58411 38.5008 2.51764 39.1231L20.0565 31.0609L37.2277 39.2646C38.2178 38.6705 39.0099 37.7935 39.4908 36.7469L20.1131 27.4399L0.395996 36.5206Z"
        fill="#4C91BF"
      />
      <path
        d="M16.3791 0L0 7.52475V11.1174L20.0849 1.86704L40 11.4003V7.77935L23.7058 0H16.3791Z"
        fill="#4C91BF"
      />
      <path
        d="M0 17.256V20.8203L20.0849 11.5983L40 21.1032V17.5106L20.1132 8.00562L0 17.256Z"
        fill="#4C91BF"
      />
      <path
        d="M14.0593 40H25.9971L20.1414 37.1995C20.1131 37.1995 16.6619 38.8119 14.0593 40Z"
        fill="#4C91BF"
      />
    </g>
    <defs>
      <clipPath id="clip0_348_5093">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Gras = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_348_4972)">
      <path
        d="M40 5.55712C40 2.48237 37.5176 0 34.4429 0H32.835L40 17.7715V5.55712Z"
        fill="white"
      />
      <path
        d="M7.24965 20.5642H0V34.6686C0 35.5431 0.22567 36.3611 0.592384 37.0945L7.24965 20.5642Z"
        fill="white"
      />
      <path
        d="M24.1748 19.6615L24.203 19.6897L32.1297 0H16.22L24.1748 19.6897V19.6615Z"
        fill="white"
      />
      <path
        d="M15.543 0H5.55709C3.49786 0 1.6925 1.12835 0.733398 2.79267L7.55991 19.7179L15.543 0Z"
        fill="white"
      />
      <path
        d="M7.58813 19.718L15.7687 40.0001H15.9661L24.1467 19.718H7.58813Z"
        fill="white"
      />
      <path
        d="M24.2031 19.718L32.3837 40.0001H32.5811L40 21.608V19.718H24.2031Z"
        fill="white"
      />
      <path
        d="M7.58792 19.718L0.620361 36.9818C1.55125 38.7871 3.41303 40.0001 5.55689 40.0001H15.7685L7.58792 19.718Z"
        fill="#23B573"
      />
      <path
        d="M7.58815 19.718L0.733427 2.79272C0.282087 3.61078 0 4.54167 0 5.55718V19.718H7.58815Z"
        fill="#23B573"
      />
      <path
        d="M24.2031 19.7179H40V17.7715L32.835 0H32.1298L24.2031 19.6897V19.7179Z"
        fill="#23B573"
      />
      <path
        d="M7.58813 19.7179H24.1467L24.1749 19.6897L16.22 0H15.543L7.58813 19.7179Z"
        fill="#23B573"
      />
      <path
        d="M24.1748 19.6898V19.718H24.1466L15.9661 40.0001H32.3836L24.203 19.718H24.1748L24.203 19.6898L24.1748 19.6616V19.6898Z"
        fill="#23B573"
      />
      <path
        d="M24.1748 19.7193H24.2044V19.6897L24.1748 19.7193Z"
        fill="#23B573"
      />
      <path
        d="M24.1467 19.7193H24.1763V19.6897L24.1467 19.7193Z"
        fill="#23B573"
      />
      <path
        d="M40 34.4429V21.6079L32.5811 39.9718H34.4428C37.4894 40 40 37.4894 40 34.4429Z"
        fill="#23B573"
      />
    </g>
    <defs>
      <clipPath id="clip0_348_4972">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Organisatie = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_348_5062)">
      <path
        d="M5.56091 0C2.47763 0 0 2.56776 0 5.7632V34.2653C0 37.4322 2.47763 40.0285 5.56091 40.0285H34.4391C37.4948 40.0285 40 37.4608 40 34.2653V5.7632C40 2.59629 37.5224 0 34.4391 0H5.56091Z"
        fill="#286396"
      />
      <path
        d="M20.2615 2.0542L4.26704 12.0114L4.9828 13.5521L4.95527 14.6077L4.26704 14.7503L4.12939 16.0913L4.7901 16.291L4.84516 35.863H35.733V16.291L36.3111 16.1769V14.6933H35.5127V13.3523L36.1734 11.9829L20.2615 2.0542Z"
        fill="#286396"
      />
      <path
        d="M36.0633 15.8632H35.7329H33.0901H28.9332H26.3179H14.2326H11.5898H7.43286H4.81759H4.45971V15.0643H5.01029H9.80038H30.7226H35.5127H36.0633V15.8632ZM35.4301 34.0657H33.3929V16.5194H35.4301V34.0657ZM35.4301 35.4923H5.09288V34.6934H7.43286H11.5898H14.2326H17.3985H23.097H26.2904H28.9057H33.0626H35.4026V35.4923H35.4301ZM7.13004 34.0657H5.09288V16.5194H7.13004V34.0657ZM13.9298 34.0657H11.8926V16.5194H13.9298V34.0657ZM22.7942 34.0657H17.7013V26.4195C17.7013 26.3624 17.7288 26.3339 17.7563 26.3339H22.7667C22.7667 26.3339 22.8217 26.3624 22.8217 26.4195V34.0657H22.7942ZM28.6304 34.0657H26.5932V16.5194H28.6304V34.0657ZM32.7873 34.0657H29.2085V16.5194H32.7873V34.0657ZM25.9876 16.5194V34.0657H23.3998V26.4195C23.3998 25.9916 23.097 25.6777 22.7667 25.6777H17.7563C17.3985 25.6777 17.1232 26.0201 17.1232 26.4195V34.0372H14.5354V16.5194H25.9876ZM11.287 34.0657H7.70816V16.5194H11.287V34.0657ZM29.5939 14.3796H10.9291L20.2615 8.55931L29.5939 14.3796ZM5.31311 13.6948L20.2615 4.3653L35.2099 13.6948V14.3796H30.8052L20.3991 7.90311C20.3166 7.84605 20.2064 7.84605 20.0963 7.90311L9.71779 14.3796H5.31311V13.6948ZM20.2615 2.36816L35.9256 12.1256L35.4026 13.0672L20.3991 3.7091C20.3166 3.65204 20.2064 3.65204 20.0963 3.7091L5.12041 13.0672L4.59735 12.1256L20.2615 2.36816ZM36.2009 14.3796H35.8155V13.5807L36.6139 12.1542C36.6689 12.0686 36.6689 11.983 36.6414 11.8974C36.6139 11.8118 36.5588 11.7262 36.5037 11.6977L20.3991 1.68342C20.3166 1.62636 20.2064 1.62636 20.0963 1.68342L4.04677 11.7262C3.96418 11.7833 3.93665 11.8403 3.90912 11.9259C3.88159 12.0115 3.90912 12.0971 3.93665 12.1827L4.735 13.6092V14.4081H4.34959C4.10183 14.4081 3.88159 14.6363 3.88159 14.9217V15.9773C3.88159 16.2626 4.10183 16.4908 4.34959 16.4908H4.51476V34.351V35.8061C4.51476 35.9773 4.65241 36.1485 4.81759 36.1485H35.7329C35.8981 36.1485 36.0357 36.0058 36.0357 35.8061V34.351V16.5194H36.2009C36.4487 16.5194 36.6689 16.2911 36.6689 16.0058V14.8931C36.6689 14.6078 36.4487 14.3796 36.2009 14.3796Z"
        fill="white"
      />
      <path
        d="M9.0844 18.6877H9.91028V23.3382H9.0844V18.6877ZM8.97429 23.9944H10.0479C10.3232 23.9944 10.5435 23.7662 10.5435 23.4523V18.5736C10.5435 18.2597 10.3232 18.0315 10.0479 18.0315H8.97429C8.69899 18.0315 8.47876 18.2597 8.47876 18.5736V23.4809C8.50629 23.7662 8.69899 23.9944 8.97429 23.9944Z"
        fill="white"
      />
      <path
        d="M22.5465 18.6877H23.3724V23.3382H22.5465V18.6877ZM22.4089 23.9944H23.4825C23.7578 23.9944 23.978 23.7376 23.978 23.4523V18.5736C23.978 18.2883 23.7578 18.0315 23.4825 18.0315H22.4089C22.1336 18.0315 21.9133 18.2597 21.9133 18.5736V23.4809C21.9409 23.7662 22.1611 23.9944 22.4089 23.9944Z"
        fill="white"
      />
      <path
        d="M17.1508 18.6877H17.9767V23.3382H17.1508V18.6877ZM17.0407 23.9944H18.1143C18.3896 23.9944 18.6099 23.7376 18.6099 23.4523V18.5736C18.6099 18.2883 18.3896 18.0315 18.1143 18.0315H17.0407C16.7654 18.0315 16.5452 18.2597 16.5452 18.5736V23.4809C16.5452 23.7662 16.7654 23.9944 17.0407 23.9944Z"
        fill="white"
      />
      <path
        d="M30.5576 18.6877H31.3835V23.3382H30.5576V18.6877ZM30.4475 23.9944H31.5211C31.7964 23.9944 32.0167 23.7376 32.0167 23.4523V18.5736C32.0167 18.2883 31.7964 18.0315 31.5211 18.0315H30.4475C30.1997 18.0315 29.9795 18.2597 29.9795 18.5736V23.4809C29.9795 23.7662 30.1722 23.9944 30.4475 23.9944Z"
        fill="white"
      />
      <path
        d="M9.0844 25.7919H9.91028V30.4424H9.0844V25.7919ZM8.97429 31.0987H10.0479C10.3232 31.0987 10.5435 30.8704 10.5435 30.5566V25.6778C10.5435 25.3925 10.3232 25.1357 10.0479 25.1357H8.97429C8.69899 25.1357 8.47876 25.3925 8.47876 25.6778V30.5851C8.50629 30.8704 8.69899 31.0987 8.97429 31.0987Z"
        fill="white"
      />
      <path
        d="M30.5576 25.7919H31.3835V30.4424H30.5576V25.7919ZM30.4475 31.0987H31.5211C31.7964 31.0987 32.0167 30.8419 32.0167 30.5566V25.6778C32.0167 25.3925 31.7964 25.1357 31.5211 25.1357H30.4475C30.1997 25.1357 29.9795 25.3925 29.9795 25.6778V30.5851C29.9795 30.8704 30.1722 31.0987 30.4475 31.0987Z"
        fill="white"
      />
      <path
        d="M18.8575 27.1042C18.6923 27.1042 18.5547 27.2469 18.5547 27.4466V32.953C18.5547 33.1242 18.6923 33.2954 18.8575 33.2954C19.0227 33.2954 19.1603 33.1528 19.1603 32.953V27.4466C19.1603 27.2469 19.0227 27.1042 18.8575 27.1042Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_348_5062">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Filter = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33333 11.3571C5.33333 11.1866 5.40357 11.0231 5.5286 10.9026C5.65362 10.782 5.82319 10.7143 6 10.7143H10C10.1768 10.7143 10.3464 10.782 10.4714 10.9026C10.5964 11.0231 10.6667 11.1866 10.6667 11.3571C10.6667 11.5276 10.5964 11.6912 10.4714 11.8117C10.3464 11.9323 10.1768 12 10 12H6C5.82319 12 5.65362 11.9323 5.5286 11.8117C5.40357 11.6912 5.33333 11.5276 5.33333 11.3571ZM2.66667 7.5C2.66667 7.3295 2.7369 7.16599 2.86193 7.04543C2.98695 6.92487 3.15652 6.85714 3.33333 6.85714H12.6667C12.8435 6.85714 13.013 6.92487 13.1381 7.04543C13.2631 7.16599 13.3333 7.3295 13.3333 7.5C13.3333 7.6705 13.2631 7.83401 13.1381 7.95457C13.013 8.07513 12.8435 8.14286 12.6667 8.14286H3.33333C3.15652 8.14286 2.98695 8.07513 2.86193 7.95457C2.7369 7.83401 2.66667 7.6705 2.66667 7.5ZM0 3.64286C0 3.47236 0.070238 3.30885 0.195262 3.18829C0.320287 3.06773 0.489856 3 0.666667 3H15.3333C15.5101 3 15.6797 3.06773 15.8047 3.18829C15.9298 3.30885 16 3.47236 16 3.64286C16 3.81335 15.9298 3.97687 15.8047 4.09743C15.6797 4.21798 15.5101 4.28571 15.3333 4.28571H0.666667C0.489856 4.28571 0.320287 4.21798 0.195262 4.09743C0.070238 3.97687 0 3.81335 0 3.64286Z"
      fill="white"
    />
  </svg>
);

export const Arrow = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.0887 11L16.4497 18.6306L9.71007 11L8 12.6847L16.4497 22L25 12.6847L23.0887 11Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowLeft = ({title, fillColor = "currentColor"}) => (
  <svg
    width="12"
    height="19"
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {title && <title>{title}</title>}
    <path
      d="M12 16.8639L3.67568 9.4438L12 1.91125L10.1622 -8.03342e-08L5.40873e-07 9.4438L10.1622 19L12 16.8639Z"
      fill={fillColor}
    />
  </svg>
);

export const ArrowRight = ({ className, title }) => (
  <svg
    className={className}
    width="12"
    height="19"
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <title>{title}</title>
    <path
      d="M2.011e-07 2.13612L8.32432 9.5562L2.27915e-08 17.0887L1.83783 19L12 9.5562L1.83783 -4.12983e-07L2.011e-07 2.13612Z"
      fill="currentColor"
    />
  </svg>
);

export const BookIcon = ({ className }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
      <title>Open PDF bestand</title>
      <desc>Deze knop opent het PDF-bestand genaamd 'hhd-2223-wbp6-hoofdlijnen-toegankelijk-wcag'.</desc>
      <path d="M10.8591 21.9491C10.7804 21.8702 10.7803 21.8702 10.7803 21.8702C10.7016 21.7913 10.623 21.7913 10.4656 21.7124C9.36397 21.1603 8.18363 20.9236 7.0033 20.7659C5.42953 20.6081 3.85576 20.8448 2.28199 21.3969C2.2033 21.3969 2.20324 21.4758 2.12455 21.5547C2.12455 21.7124 2.12455 21.7913 2.12455 21.9491H10.8591ZM21.6393 21.9491C21.718 21.4758 21.718 21.4758 21.2459 21.318C20.6951 21.1603 20.1443 21.0025 19.5935 20.9236C17.7049 20.6081 15.8164 20.687 14.0066 21.3969C13.6918 21.5547 13.2984 21.7124 12.9836 21.8702C12.9836 21.8702 12.9836 21.8702 12.9836 21.9491H21.6393ZM4.56397 2.22878C4.56397 2.30766 4.56397 2.38654 4.56397 2.46542C4.56397 6.80389 4.56397 11.2212 4.56397 15.5597C4.56397 15.7175 4.56393 15.7963 4.72131 15.7963C7.23934 16.4274 9.28526 17.8473 10.9377 19.8982C11.0951 20.1348 11.2525 20.2926 11.4098 20.5292C11.4098 20.5292 11.4098 20.5292 11.4885 20.5292C11.3311 20.0559 11.2525 19.5038 11.0164 19.0305C10.2295 16.9796 8.81312 15.6386 6.68852 15.0864C6.21639 15.0075 6.21641 14.9287 6.21641 14.4554C6.21641 11.6945 6.21641 8.8548 6.21641 6.09396C6.21641 5.0685 6.21641 4.12192 6.21641 3.09647C6.21641 3.01759 6.13774 2.85983 6.13774 2.85983C5.50824 2.62318 5.0361 2.46542 4.56397 2.22878ZM3.77709 7.35606C3.30496 7.51382 2.83279 7.67158 2.36066 7.82934C2.20328 7.90822 2.12455 7.98711 2.12455 8.22375C2.12455 12.3256 2.12455 16.3485 2.12455 20.4503V20.7659C5.03603 19.8982 7.9475 19.8193 10.7803 21.1603C10.7016 21.0814 10.7016 21.0025 10.7016 21.0025C9.04916 18.715 7.0033 17.2162 4.2492 16.5063C3.77707 16.3485 3.69832 16.3485 3.69832 15.8752C3.69832 13.351 3.69832 10.8268 3.69832 8.38151C3.77701 7.98711 3.77709 7.75046 3.77709 7.35606ZM6.84586 0.966677C6.84586 1.04556 6.84586 1.12444 6.84586 1.12444C6.84586 5.46291 6.84586 9.88025 6.84586 14.2187C6.84586 14.3765 6.92461 14.4554 7.0033 14.4554C9.0492 15.0075 10.5443 16.3485 11.4098 18.3206C11.4098 18.3994 11.4885 18.3994 11.4885 18.4783C11.4885 18.3205 11.4885 18.2417 11.4885 18.2417C11.4885 15.0864 11.4885 12.0101 11.4885 8.8548C11.4885 7.90823 11.4886 7.04053 11.2525 6.09396C10.9377 4.51633 10.3082 3.17535 9.04918 2.07101C8.49836 1.51884 7.71144 1.12444 6.84586 0.966677ZM20.2229 4.98962C20.1442 4.98962 20.0656 4.98962 19.9869 4.98962C19.2 5.0685 18.4131 5.14738 17.6262 5.30515C15.659 5.69955 13.9279 6.56724 12.4328 7.82934C12.2754 7.98711 12.1967 8.06599 12.1967 8.30263C12.1967 12.5622 12.1967 16.7429 12.1967 21.0025V21.318C14.5574 19.5038 17.2328 18.6361 20.1442 18.4783V18.1628C20.1442 15.7175 20.1442 13.351 20.1442 10.9057C20.1442 10.8268 20.1442 10.6691 20.1442 10.5902C20.2229 10.4324 20.3016 10.3535 20.5377 10.3535C20.6951 10.3535 20.7738 10.4324 20.8525 10.6691C20.8525 10.7479 20.8525 10.8268 20.8525 10.9057C20.8525 13.5088 20.8525 16.033 20.8525 18.6361C20.8525 19.1094 20.7738 19.1882 20.3017 19.1882C18.8853 19.1882 17.4689 19.4249 16.1311 19.8982C15.8951 19.9771 15.659 20.0559 15.4229 20.1348C17.4688 19.8193 19.5148 19.9771 21.482 20.6081V20.2926V11.4579C21.482 10.3535 21.482 9.24921 21.482 8.14487C21.482 8.06599 21.4819 7.90823 21.4032 7.90823C21.2459 7.82934 21.0099 7.75046 20.7738 7.67158C20.7738 7.98711 20.7738 8.22375 20.7738 8.53928C20.7738 8.77592 20.6164 8.93368 20.459 8.93368C20.223 8.93368 20.0656 8.77592 20.0656 8.53928C20.0656 8.22375 20.0656 7.90822 20.0656 7.5927C20.223 6.72501 20.2229 5.85731 20.2229 4.98962ZM1.4951 8.46039C1.25904 8.46039 1.02295 8.46039 0.786885 8.46039C0.629508 8.46039 0.629547 8.61816 0.629547 8.69704C0.629547 9.64361 0.629547 10.5113 0.629547 11.4579C0.629547 13.9821 0.629547 16.5852 0.629547 19.1094C0.629547 19.1882 0.629547 19.2671 0.629547 19.346C0.629547 19.5038 0.47215 19.5827 0.314773 19.5827C0.157396 19.5827 0 19.5038 0 19.346C0 19.2671 0 19.1882 0 19.1094C0 15.6386 0 12.1678 0 8.61816C0 7.98711 0.314716 7.67158 0.944224 7.67158C1.02291 7.67158 1.10164 7.67158 1.18033 7.67158C1.3377 7.67158 1.49508 7.67158 1.57377 7.43494C1.57377 7.35606 1.73117 7.19829 1.88854 7.19829C2.43936 6.96165 3.06883 6.80389 3.61965 6.64612C3.69834 6.64612 3.77707 6.56724 3.85576 6.56724C3.85576 5.62067 3.85576 4.75298 3.85576 3.8064C3.85576 3.17535 3.85576 2.5443 3.85576 1.91325C3.85576 1.51884 4.0131 1.36108 4.40654 1.43996C4.95736 1.59773 5.5869 1.75549 6.21641 1.91325C6.21641 1.83437 6.21641 1.75549 6.21641 1.67661C6.21641 1.2822 6.21641 0.808914 6.21641 0.414508C6.21641 0.0989829 6.37377 -0.0587796 6.68852 0.0201016C9.28525 0.651152 10.9377 2.30766 11.8033 4.83186C12.0393 5.46291 12.118 6.17284 12.2754 6.80389C12.2754 6.88277 12.2754 6.96165 12.2754 7.04053C12.5901 6.80389 12.9836 6.56725 13.2984 6.3306C14.9508 5.22626 16.7607 4.59521 18.7279 4.35857C19.3574 4.27969 19.9082 4.27969 20.5377 4.20081C20.8524 4.20081 21.0098 4.27969 21.0098 4.59521C21.0098 5.22626 21.0098 5.93619 21.0098 6.56724C21.0098 6.72501 21.0885 6.80389 21.2459 6.88277C21.5607 6.96165 21.8754 7.11941 22.1115 7.19829C22.2688 7.27717 22.2689 7.43494 22.4262 7.51382C22.5049 7.5927 22.5836 7.67158 22.5836 7.67158C22.7409 7.67158 22.8984 7.67158 23.1344 7.67158C23.6066 7.67158 24 7.98711 24 8.53928C24 13.4299 24 18.2417 24 23.1323C24 23.6056 23.6853 24 23.1344 24C19.7508 24 16.3672 24 12.9836 24C12.8262 24 12.6689 23.9211 12.5902 23.8422C12.1967 23.5267 11.8033 23.5267 11.4098 23.8422C11.3311 23.9211 11.1738 24 11.0164 24C7.63279 24 4.32783 24 0.944224 24C0.393404 24 0.0786693 23.6845 0.0786693 23.1323C0.0786693 22.5801 0.0786693 22.028 0.0786693 21.4758C0.0786693 21.1603 0.236046 21.0814 0.472112 21.0814C0.708178 21.0814 0.786885 21.2392 0.786885 21.4758C0.786885 22.028 0.786885 22.5013 0.786885 23.0534C0.786885 23.2112 0.865612 23.2901 1.02299 23.2901C4.24922 23.2901 7.55406 23.2901 10.7803 23.2901C10.859 23.2901 10.9377 23.2112 11.0164 23.2112C11.5672 22.7379 12.3541 22.7379 12.9049 23.2112C12.9836 23.2901 13.0623 23.2901 13.1409 23.2901C16.3672 23.2901 19.6721 23.2901 22.8983 23.2901C23.1344 23.2901 23.1344 23.2112 23.1344 22.9745C23.1344 18.1628 23.1344 13.4299 23.1344 8.61816C23.1344 8.38151 23.0557 8.30263 22.8983 8.38151C22.741 8.38151 22.5836 8.38151 22.3476 8.38151V8.69704V21.8702C22.3476 22.4224 22.2688 22.5013 21.718 22.5013H2.04588C1.57375 22.5013 1.4951 22.4224 1.4951 21.9491C1.4951 17.5317 1.4951 13.0355 1.4951 8.61816V8.46039Z" />
    </svg>
);

export const AccessibilityIcon = ({ className, stroke }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none" className={className} style={{"color": "transparent"}}>
      <path d="M16.5021 9.8125C17.8388 9.8125 18.9246 8.73398 18.9246 7.40625C18.9246 6.07852 17.8388 5 16.5021 5C15.1654 5 14.0797 6.07852 14.0797 7.40625C14.0797 8.73398 15.1654 9.8125 16.5021 9.8125Z" fill={stroke}/>
      <path d="M24.1157 9.84688L24.0941 9.85117L24.0768 9.85547C24.0335 9.86836 23.9903 9.88125 23.947 9.89414C23.1424 10.1305 19.2361 11.2219 16.4805 11.2219C13.9239 11.2219 10.3681 10.2766 9.23035 9.9543C9.11788 9.91133 9.00108 9.87266 8.88428 9.84258C8.06236 9.62774 7.5 10.457 7.5 11.2133C7.5 11.9652 8.17916 12.3219 8.86265 12.5797V12.5926L12.9809 13.8688C13.4005 14.0277 13.513 14.191 13.5692 14.3328C13.7466 14.7883 13.6038 15.6906 13.5562 16.0043L13.3053 17.9379L11.9167 25.5133C11.9124 25.5348 11.9081 25.5562 11.9037 25.5777L11.8951 25.6336C11.7956 26.3254 12.3061 27 13.2794 27C14.1273 27 14.5036 26.4199 14.6637 25.6293C14.6637 25.6293 15.8749 18.8574 16.4805 18.8574C17.0862 18.8574 18.332 25.6293 18.332 25.6293C18.4964 26.4199 18.8684 27 19.7163 27C20.6896 27 21.2044 26.3254 21.1006 25.6293C21.0919 25.5691 21.0789 25.5133 21.066 25.4531L19.6601 17.9465L19.4092 16.0129C19.2275 14.8871 19.3745 14.5133 19.4221 14.4273C19.4221 14.4273 19.4265 14.423 19.4265 14.4188C19.474 14.3328 19.686 14.1395 20.1835 13.9547L24.0465 12.6141C24.0681 12.6098 24.0941 12.6012 24.1157 12.5926C24.8079 12.3348 25.5 11.9781 25.5 11.2219C25.5 10.4656 24.9376 9.63203 24.1157 9.84688Z" fill={stroke}/>
      <circle cx="16.5" cy="16" r="15.5" stroke={stroke}/>
    </svg>
);

export const ThemeFilterMobileIcon = ({ className }) => (
    <svg
        width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}
    >
      <circle
          cx="12"
          cy="12"
          r="11"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
      />
      <rect
          x="16"
          y="11"
          width="2"
          height="8"
          transform="rotate(90 16 11)"
          fill="currentColor"
      />
    </svg>
);

export const PlusIcon = ({ className, areaOpen, title }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
      <title>{areaOpen ? `Verberg gebied van maatregel: ${title}` : `Toon gebied van maatregel: ${title}`}</title>
      <circle
          cx="12"
          cy="12"
          r="11"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
      />
      {!areaOpen && (
          <rect x="11" y="8" width="2" height="8" fill="currentColor"/>
      )}
      <rect
          x="16"
          y="11"
          width="2"
          height="8"
          transform="rotate(90 16 11)"
          fill="currentColor"
      />
    </svg>
);



